import Vue from "vue";
import VueRouter from "vue-router";
import StatusTableau from "../views/StatusTableau.vue";
import SDSCenter from "../views/SDSCenter";
import MessageCenter from "../views/MessageCenter";
import VNCView from "../views/VNCView";
import LoginView from "../views/LoginView";
import TicketView from "../views/TicketsView";
import LockingSystem from "../views/LockingSystem";
import FAQ from "../views/FAQ";
import NotalarmView from "../views/NotalarmView";
import SirenenView from "../views/SirenenView";
import PhonebookView from "../views/PhonebookView";
import TestView from "../views/TestView";
import PublicTicketView from "../views/public/PublicTicketView";
import TerminPublicView from "../views/TerminPublicView";
import TerminView from "../views/TerminView";
import PublicShopView from "../views/public/PublicShopView.vue";
import ShopView from "../views/ShopView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: LoginView,
    meta: { title: 'SFW - Login' }
  },
  {
    path: "/",
    name: "Home",
    component: StatusTableau,
    meta: {
      title: 'SFW - Home',
    }
  },
  {
    path: "/tickets/:id?",
    name: "TicketView",
    component: TicketView,
    meta: {
      title: 'SFW - Tickets',
      permission: ['SFW_Alle_ELO'],
    }
  },
  {
    path: "/cmdb/:id?",
    name: "CMDBView",
    component: TicketView,
    meta: {
      title: 'SFW - CMDB',
      permission: ['SFW_Alle_ELO'],
    }
  },
  {
    path: "/sds",
    name: "SDSCenter",
    component: MessageCenter,
  },
  {
    path: "/sdsold",
    name: "SDSCenter",
    component: SDSCenter,
  },
  {
    path: "/vncs",
    name: "VNCView",
    component: VNCView,
    meta: {
      title: 'SFW - VNC',
      permission: ['SFW_ELOCOM_Vnc'],
      requirePrivateNet: true
    }
  },
  {
    path: "/phonebook",
    name: "PhoneBook",
    component: PhonebookView,
    meta: {
      title: 'SFW - Telefon',
      permission: ['SFW_ELOCOM_Phonebook']
    }
  },
  /*{
    path: "/smsbroadcast",
    name: "SMSBroadcast",
    component: SMSBroadcast,
    meta: {
      title: 'SFW - SMSBroadcast',
      permission: ['SFW_Alle_ELO']
    }
  },*/
  {
    path: "/kentix",
    name: "Kentix",
    component: LockingSystem,
    meta: {
      title: 'SFW - Schließanlage',
      permission: ['SFW_ELOCOM_Kentix'],
    }
  },
  {
    path: "/notalarm",
    name: "Notalarm",
    component: NotalarmView,
    meta: {
      title: 'SFW - Notalarm',
      permission: ['SFW_ELOCOM_Notalarm', 'SFW_Alle_ELO'],
      requirePrivateNet: true
    }
  },
  {
    path: "/sirenen",
    name: "Sirenen",
    component: SirenenView,
    meta: {
      title: 'SFW - Sirenen',
      permission: ['SFW_ELOCOM_Sirenen']
    }
  },
  {
    path: "/shop",
    name: "Shop",
    component: ShopView,
    meta: {
      title: 'SFW - Shop',
      permission: ['SFW_ELOCOM_Shop'],
    },
  },
  {
    path: "/termine",
    name: "Terminbuchung",
    component: TerminView,
    meta: {
      title: 'SFW - Terminbuchung',
      permission: ['SFW_ELOCOM_Sirenen'],
    },
  },
  {
    path: "/faq",
    name: "FAQ",
    component: FAQ,
    meta: { title: 'SFW - FAQ' }
  },
  {
    path: "/public/termine/:code?",
    name: "Terminbuchung",
    component: TerminPublicView,
    meta: { title: 'SFW - Terminbuchung' },
  },
  {
    path: "/public/shop",
    name: "PublicShop",
    component: PublicShopView,
    meta: { title: 'SFW - Shop' }
  },
  {
    path: "/public",
    name: "FAQ",
    component: FAQ,
    meta: { title: 'SFW - FAQ' },
    children: [
      {
        path: "ticket",
        name: "PublicTicket",
        component: PublicTicketView,
        meta: { title: 'Public Ticket' }
      },
      {
        path: "shop",
        name: "PublicShop",
        component: PublicShopView,
        meta: { title: 'SFW - Shop' }
      },
    ]
  },
  {
    path: "/test",
    name: "Test",
    component: TestView,
    meta: { title: 'Glückwunsch' }
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Home.vue"),
  },
];

const router = new VueRouter({
  routes,
});

/*
// Navigation Guard mit Permissions
import { hasAccess } from "@/plugins/permissions";

router.beforeEach((to, from, next) => {
  if (this.$store.state.user.id !== null){
    const user = router.app.$store?.state?.user;
    const inPrivateNet = router.app.$store?.getters?.inPrivateNet;

    if (to.meta?.permission || to.meta?.requirePrivateNet) {
      const ok = hasAccess(user, to.meta, inPrivateNet);
      if (!ok) return next("/");
    }

    if (to.meta?.title) {
      document.title = to.meta.title;
    }
  }


  next();
});
*/

export default router;
